var exports = {
  "wx": "xf0b3b88a--4ba3dd--header",
  "jk": "xf0b3b88a--4ba3dd--term",
};

module.exports = exports;
